export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="4"
        y="4"
        width="56"
        height="56"
        rx="12"
        fill="#fb923c"
        stroke="#111318"
        strokeWidth="4"
      />
      <polygon
        points="36 12 14 36 28 36 26 52 50 28 34 28 36 12"
        fill="#ffffff"
        stroke="#111318"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
